// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"70705d01","455":"64fad149","977":"3711786f"}[chunkId] + ".chunk.js";
};